(() => {
  if (window.tblStickyBoot) { window.tblStickyBoot(); return; }
  const boot = () => {
    document.querySelectorAll('[id^="ProductStickyCart-"]').forEach(bar => {
      if (bar.dataset.observed) return;
      const scope = bar.closest('product-info');
      const target = scope?.querySelector('.product-form__buttons');
      if (!target) return;
      bar.dataset.observed = 'true';
      let queued = false;
      const update = () => {
        queued = false;
        const currentTarget = scope.querySelector('.product-form__buttons');
        const show = currentTarget && currentTarget.getBoundingClientRect().bottom < 0 && !window.Shopify?.designMode;
        bar.classList.toggle('is-hidden', !show);
      };
      const queueUpdate = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      };
      const observer = new IntersectionObserver(update, {threshold:0});
      observer.observe(target);
      window.addEventListener('scroll', queueUpdate, {passive:true});
      window.addEventListener('resize', queueUpdate);
      update();
      const unload = event => {
        if (!event.target.contains(bar)) return;
        observer.disconnect();
        window.removeEventListener('scroll', queueUpdate);
        window.removeEventListener('resize', queueUpdate);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  window.tblStickyBoot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
